export default {
      id: "saving-1-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#saving-1",
      toString: function () {
        return this.url;
      }
    }